import type React from 'react';
import { useEffect, useRef, useState } from 'react';

import { UserManagementContext } from 'context/userManagementContext';
import { useUserManagementService } from 'hooks/userManagement/useUserManagementService';
import { AuthenticatedUser } from 'mocks/auth/authenticatedUserMock';
import type UserManagementService from 'services/userManagement/userManagementService';
import { type ClubSparkAuthenticationInterface } from 'typedefs/authTypes';
import { isStandalone } from 'utils/environment';

const UserManagementContainer: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const userManagementServiceRef = useRef<UserManagementService>(null);
  userManagementServiceRef.current = useUserManagementService();

  const [authenticatedUser, setAuthenticatedUser] = useState<ClubSparkAuthenticationInterface>(
    userManagementServiceRef.current.getFromStorage(),
  );
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const isStandAloneDemo = isStandalone();
    if (!isStandAloneDemo) {
      setLoading(true);
      userManagementServiceRef.current
        .getCurrentUser()
        .then((response) => {
          setAuthenticatedUser(response);
          setLoading(false);
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            setAuthenticatedUser(undefined);
            userManagementServiceRef.current.saveToStorage();
            setLoading(false);
          }
        });
    } else {
      // This is for stand-alone demo, no communication with server so no need for token and TEV
      setLoading(false);
      const auth = userManagementServiceRef.current.saveToStorage(AuthenticatedUser, 'demo');
      setAuthenticatedUser(auth);
    }
  }, []);

  return (
    <UserManagementContext.Provider value={{ user: authenticatedUser?.user, loading }}>
      {children}
    </UserManagementContext.Provider>
  );
};

export default UserManagementContainer;
